<div *ngIf="loading" class="d-flex justify-content-center align-items-center py-5">
  <app-spinner></app-spinner>
</div>

<div *ngIf="!loading">

  <!-- Header -->
  <div class="glv-header mb-4">
    <a class="glv-back-btn" [routerLink]="['/', langSrcSrv.current.shortCode, 'themes', idTheme]">
      <i class="fa-solid fa-arrow-left"></i>
      <span translate>Niveaux</span>
    </a>
    <h2 class="glv-level-name">{{ level.name }}</h2>
    <div class="glv-header-spacer"></div>
  </div>

  <ng-container *ngIf="!level.locked">

    <!-- Resource cards -->
    <div class="glv-resources mb-4"
      *ngIf="(!level.hideWord) || (lessons?.length && !level.hideLesson) || cultures?.length">

      <div class="glv-resource-card" *ngIf="!level.hideWord" (click)="openVocabulary()">
        <div class="glv-resource-icon glv-resource-icon-vocab">
          <i class="fa-solid fa-book-open"></i>
        </div>
        <div class="glv-resource-body">
          <div class="glv-resource-title" translate>Vocabulaire</div>
          <div class="glv-resource-sub" translate>Nouveau vocabulaire du niveau</div>
        </div>
        <i class="fa-solid fa-chevron-right glv-resource-arrow"></i>
      </div>

      <div class="glv-resource-card" *ngIf="lessons?.length && !level.hideLesson" (click)="openLessons()">
        <div class="glv-resource-icon glv-resource-icon-lessons">
          <i class="fa-solid fa-graduation-cap"></i>
        </div>
        <div class="glv-resource-body">
          <div class="glv-resource-title" translate>Leçons</div>
          <div class="glv-resource-sub" translate>Apprends de nouvelles règles</div>
        </div>
        <i class="fa-solid fa-chevron-right glv-resource-arrow"></i>
      </div>

      <div class="glv-resource-card" *ngIf="cultures?.length" (click)="openCultures()">
        <div class="glv-resource-icon glv-resource-icon-culture">
          <i class="fa-solid fa-earth-europe"></i>
        </div>
        <div class="glv-resource-body">
          <div class="glv-resource-title" translate>Point culture</div>
          <div class="glv-resource-sub" translate>Us & Coutumes et plus encore</div>
        </div>
        <i class="fa-solid fa-chevron-right glv-resource-arrow"></i>
      </div>

    </div>

    <!-- Games -->
    <ng-container *ngIf="games">

      <!-- Training games -->
      <ng-container *ngIf="getTrainingGames().length">
        <div class="glv-section-label mb-3">
          <i class="fa-solid fa-eye"></i>
          <span translate>Découverte</span>
        </div>
        <div class="row mb-4">
          <div class="col-6 col-md-4 col-lg-3 mb-3"
            *ngFor="let game of getTrainingGames() | sortBy:'position'; trackBy: trackById">
            <app-game-item [game]="game" (open)="openGame(game.uniqid)"></app-game-item>
          </div>
        </div>
      </ng-container>

      <!-- Classic / evaluation games -->
      <ng-container *ngIf="getClassicGames().length">
        <div class="glv-section-label glv-section-label-eval mb-3">
          <i class="fa-solid fa-chart-line"></i>
          <span translate>Progression</span>
        </div>
        <div class="row">
          <div class="col-6 col-md-4 col-lg-3 mb-3"
            *ngFor="let game of getClassicGames() | sortBy:'position'; trackBy: trackById">
            <app-game-item [game]="game" (open)="openGame(game.uniqid)"></app-game-item>
          </div>
        </div>
      </ng-container>

    </ng-container>

  </ng-container>

</div>
